// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-widget-container {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  width: 100%;
  box-sizing: border-box;
  background: var(--surface-primary);
  color: var(--text-primary);
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 520px;
}

.chart-top-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 0 12px;
  flex-wrap: wrap;
}

.chart-toolbar-column {
  margin-left: auto;
  display: flex;
}

.chart-info-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 4px 12px;
  font-size: 12px;
  border-bottom: 1px solid var(--border-line);
  min-height: 32px;
}

.chart-info-interval,
.chart-info-period {
  color: var(--text-label);
}
.chart-info-sep {
  color: var(--border-line);
}
.chart-info-symbol {
  font-weight: 700;
  font-size: 13px;
}
.chart-info-price {
  font-weight: 600;
  margin-left: 4px;
}
.chart-info-change {
  font-weight: 500;
}

.chart-info-badge {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.chart-info-ta-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.ta-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 7px;
  border: 1px solid;
  border-radius: 10px;
  font-size: 11px;
  color: var(--text-primary);
}
.ta-tag-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.panels-layer {
  position: relative;
  z-index: 100;
}

.settings-panel {
  width: max-content;
  min-width: 260px;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: visible;
  background: var(--surface-primary);
  border: 1px solid var(--border-line);
  border-radius: 6px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.14);
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.settings-panel-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.settings-section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-label);
  margin-top: 4px;
}

.settings-divider {
  height: 1px;
  background: var(--border-line);
  margin: 2px 0;
}

.settings-count {
  font-size: 11px;
  font-weight: 400;
  color: var(--text-label);
}

.reset-button {
  background: none;
  border: 1px solid var(--border-line);
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  color: var(--text-label);
  align-self: flex-start;
  transition: background 0.15s;
}
.reset-button:hover {
  background: var(--surface-tertiary);
}
.reset-button-small {
  font-size: 11px;
  padding: 2px 7px;
}

.color-input {
  width: 28px;
  height: 24px;
  border: 1px solid var(--border-line);
  border-radius: 3px;
  padding: 1px;
  cursor: pointer;
}

.number-input {
  width: 54px;
  border: 1px solid var(--border-line);
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
  background: var(--surface-primary);
  color: var(--text-primary);
}

.config-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.config-label {
  font-size: 11px;
  color: var(--text-label);
}

.thickness-buttons,
.style-buttons {
  display: flex;
  gap: 3px;
}

.thickness-button,
.style-button {
  padding: 3px 7px;
  font-size: 11px;
  background: var(--surface-tertiary);
  border: 1px solid var(--border-line);
  border-radius: 3px;
  cursor: pointer;
  color: var(--text-primary);
  transition:
    background 0.12s,
    border-color 0.12s;
}

.chart-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 450px;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

@media (hover: none) and (pointer: coarse) {
  .chart-body {
    overscroll-behavior: contain;
  }
}

.chart-view {
  flex-shrink: 0;
  display: flex;
  position: relative;
}

.chart-view-loading {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-primary);
}

.chart-iframe {
  width: 100%;
  border: none;
  display: block;
  touch-action: pan-y;
}

@container (max-width: 600px) {
  .chart-iframe--no-pointer {
    pointer-events: none;
  }

  .chart-top-row {
    flex-direction: column-reverse;
    gap: 6px;
    position: relative;
    align-items: flex-start;
    flex-wrap: nowrap;
  }
}

/* ── Clear All confirmation modal ── */

@keyframes ac-overlay-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes ac-dialog-in {
  from {
    opacity: 0;
    transform: scale(0.92) translateY(-8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.clear-confirm-overlay {
  position: absolute;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  animation: ac-overlay-in 180ms ease;
}

.clear-confirm-dialog {
  background: var(--surface-primary);
  border-radius: 4px;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 260px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  animation: ac-dialog-in 200ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

.clear-confirm-message {
  color: var(--text-primary);
}

.clear-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.clear-confirm-btn {
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid var(--border-input);
  cursor: pointer;
  font-size: 13px;
}

.clear-confirm-btn--cancel {
  background: var(--surface-primary);
  color: var(--text-primary);
}

.clear-confirm-btn--cancel:hover {
  background: var(--surface-tertiary);
}

.clear-confirm-btn--ok {
  background: var(--color-brand);
  color: #fff;
  border-color: var(--color-brand);
}

.clear-confirm-btn--ok:hover {
  opacity: 0.88;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/AdvanceChartWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B;;sBAEoB;AACtB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;;AAEvC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,0CAA0C;EAC1C,+DAA+D;AACjE;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".chart-widget-container {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  width: 100%;\n  box-sizing: border-box;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 520px;\n}\n\n.chart-top-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 0 12px;\n  flex-wrap: wrap;\n}\n\n.chart-toolbar-column {\n  margin-left: auto;\n  display: flex;\n}\n\n.chart-info-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 4px 12px;\n  font-size: 12px;\n  border-bottom: 1px solid var(--border-line);\n  min-height: 32px;\n}\n\n.chart-info-interval,\n.chart-info-period {\n  color: var(--text-label);\n}\n.chart-info-sep {\n  color: var(--border-line);\n}\n.chart-info-symbol {\n  font-weight: 700;\n  font-size: 13px;\n}\n.chart-info-price {\n  font-weight: 600;\n  margin-left: 4px;\n}\n.chart-info-change {\n  font-weight: 500;\n}\n\n.chart-info-badge {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.chart-info-ta-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n.ta-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 1px 7px;\n  border: 1px solid;\n  border-radius: 10px;\n  font-size: 11px;\n  color: var(--text-primary);\n}\n.ta-tag-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.panels-layer {\n  position: relative;\n  z-index: 100;\n}\n\n.settings-panel {\n  width: max-content;\n  min-width: 260px;\n  max-height: 70vh;\n  overflow-y: auto;\n  overflow-x: visible;\n  background: var(--surface-primary);\n  border: 1px solid var(--border-line);\n  border-radius: 6px;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.14);\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.settings-panel-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.settings-section-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-label);\n  margin-top: 4px;\n}\n\n.settings-divider {\n  height: 1px;\n  background: var(--border-line);\n  margin: 2px 0;\n}\n\n.settings-count {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--text-label);\n}\n\n.reset-button {\n  background: none;\n  border: 1px solid var(--border-line);\n  border-radius: 4px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n  color: var(--text-label);\n  align-self: flex-start;\n  transition: background 0.15s;\n}\n.reset-button:hover {\n  background: var(--surface-tertiary);\n}\n.reset-button-small {\n  font-size: 11px;\n  padding: 2px 7px;\n}\n\n.color-input {\n  width: 28px;\n  height: 24px;\n  border: 1px solid var(--border-line);\n  border-radius: 3px;\n  padding: 1px;\n  cursor: pointer;\n}\n\n.number-input {\n  width: 54px;\n  border: 1px solid var(--border-line);\n  border-radius: 4px;\n  padding: 3px 6px;\n  font-size: 12px;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n\n.config-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.config-label {\n  font-size: 11px;\n  color: var(--text-label);\n}\n\n.thickness-buttons,\n.style-buttons {\n  display: flex;\n  gap: 3px;\n}\n\n.thickness-button,\n.style-button {\n  padding: 3px 7px;\n  font-size: 11px;\n  background: var(--surface-tertiary);\n  border: 1px solid var(--border-line);\n  border-radius: 3px;\n  cursor: pointer;\n  color: var(--text-primary);\n  transition:\n    background 0.12s,\n    border-color 0.12s;\n}\n\n.chart-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  min-height: 450px;\n  position: relative;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (hover: none) and (pointer: coarse) {\n  .chart-body {\n    overscroll-behavior: contain;\n  }\n}\n\n.chart-view {\n  flex-shrink: 0;\n  display: flex;\n  position: relative;\n}\n\n.chart-view-loading {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--surface-primary);\n}\n\n.chart-iframe {\n  width: 100%;\n  border: none;\n  display: block;\n  touch-action: pan-y;\n}\n\n@container (max-width: 600px) {\n  .chart-iframe--no-pointer {\n    pointer-events: none;\n  }\n\n  .chart-top-row {\n    flex-direction: column-reverse;\n    gap: 6px;\n    position: relative;\n    align-items: flex-start;\n    flex-wrap: nowrap;\n  }\n}\n\n/* ── Clear All confirmation modal ── */\n\n@keyframes ac-overlay-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes ac-dialog-in {\n  from {\n    opacity: 0;\n    transform: scale(0.92) translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.clear-confirm-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.35);\n  animation: ac-overlay-in 180ms ease;\n}\n\n.clear-confirm-dialog {\n  background: var(--surface-primary);\n  border-radius: 4px;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 260px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);\n  animation: ac-dialog-in 200ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.clear-confirm-message {\n  color: var(--text-primary);\n}\n\n.clear-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.clear-confirm-btn {\n  height: 32px;\n  padding: 0 16px;\n  border-radius: 4px;\n  border: 1px solid var(--border-input);\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.clear-confirm-btn--cancel {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n\n.clear-confirm-btn--cancel:hover {\n  background: var(--surface-tertiary);\n}\n\n.clear-confirm-btn--ok {\n  background: var(--color-brand);\n  color: #fff;\n  border-color: var(--color-brand);\n}\n\n.clear-confirm-btn--ok:hover {\n  opacity: 0.88;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
